import { render, staticRenderFns } from "./Linea.vue?vue&type=template&id=4b68bdce&lang=pug"
import script from "./Linea.vue?vue&type=script&lang=js"
export * from "./Linea.vue?vue&type=script&lang=js"
import style0 from "./Linea.vue?vue&type=style&index=0&id=4b68bdce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports